import PropTypes from 'prop-types';
import ArticleActionAnchor from '../articleActionAnchor';
import Icon from '../../icon';
import { PiiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';
import { createDownloadLink } from '../../../utils/linkCreator';
import { analyticsFormat, analyticsScope, trackAdobeEvent } from '../../../utils/trackers/adobe';

export default function SavePdfAnchor({ pdfPath, savePdfEventData, onClick }) {
  const memoizedOnClick = () => {
    if (savePdfEventData) {
      trackAdobeEvent('contentDownload', savePdfEventData);
    }

    if (onClick) {
      onClick({
        component: 'savepdf',
        format: analyticsFormat.MIME_PDF,
        scope: analyticsScope.FULL,
      });
    }
  };

  return (
    <ArticleActionAnchor
      icon={<Icon.Download height={18} />}
      href={createDownloadLink(pdfPath)}
      label="Save PDF"
      onClick={memoizedOnClick}
    />
  );
}

SavePdfAnchor.propTypes = {
  pdfPath: PropTypes.string.isRequired,
  savePdfEventData: PiiArticleEventsPropTypes.savePdf,
  onClick: PropTypes.func,
};

SavePdfAnchor.defaultProps = {
  savePdfEventData: undefined,
  onClick: undefined,
};
